<template>
    <div class="mx-2 mx-lg-5">
         <div class="card mt-3">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>{{ $t("headers.guestbooks") }}</h3>
                <router-link
                    v-if="$store.getters.hasGatehousePerm('add_guestbook')"
                    :to="{ name: 'guestbookAddView' }"
                    class="btn btn-sm btn-success me-3 d-inline-flex align-items-center"
                >
                    <icon icon="Plus" class="me-2"></icon>
                    <span class="fs-6 fw-bold">{{ $t("utils.addRecord") }}</span>
                </router-link>
            </div>
            <div class="card-body">
                <div class="row mb-5 align-items-end">
                    <div class="col-12 col-md-4">
                        <label class="form-label fw-bold">
                            {{ $t("guestbook.name") }}
                        </label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="filters.guest_name"
                            :placeholder="$t('guestbook.name')"
                        />
                    </div>

                    <div class="col-12 col-md-3">
                        <label class="form-label fw-bold">
                            {{ $t("guestbook.from") }}
                        </label>
                        <input
                            type="date"
                            class="form-control"
                            v-model="filters.expected_from"
                        />
                    </div>

                    <div class="col-12 col-md-3">
                        <label class="form-label fw-bold">
                            {{ $t("guestbook.to") }}
                        </label>
                        <input
                            type="date"
                            class="form-control"
                            v-model="filters.expected_to"
                        />
                    </div>

                     <div class="col-12 col-md-2 ms-auto d-flex">
                        <button
                            class="btn btn-secondary w-100"
                            @click="resetFilters"
                        >
                            {{ $t("utils.clearFilters") }}
                        </button>
                    </div>
                </div>


                <GuestbookProvider
                    :api-url="`/${$route.params.slug}/guestbooks`"
                    :filters="filters"
                    v-slot="p"
                >
                    <GuestbookTable
                        :items="p.items"
                        :total-count="p.totalCount"
                        :page="p.page"
                        :per-page="p.perPage"
                        @page-change="p.setPage"
                        @per-page-change="p.setPerPage"
                        @refresh="() => p.refresh()"
                    />
                </GuestbookProvider>
            </div>
         </div>
    </div>

</template>

<script>
import Icon from '@/components/Icon.vue';
import GuestbookTable from '@/components/GuestbookTable.vue';
import GuestbookProvider from '@/components/GuestbookProvider.vue';

export default {
    components: {
        Icon,
        GuestbookTable,
        GuestbookProvider,
    },
    data() {
        return {
            filters: {
                guest_name: "",
                expected_from: "",
                expected_to: "",
            }
        }
    },
    methods: {
        resetFilters() {
            this.filters.guest_name = "";
            this.filters.expected_from = "";
            this.filters.expected_to = "";
        },
    },
}
</script>